import fromAnyToString from 'utils/converters/fromAnyToString';

const CODE_LENGTH = 6;
const RE_DIGITS = /^[0-9]+$/;

const validateVerificationCode = (options) => {
  if (!options) return null;
  if (options.value === '') return false;
  if (!options.value) return null;

  const { value } = options;
  if (Array.isArray(value)) {
    const string = value.join('');
    return RE_DIGITS.test(string) && string.length === CODE_LENGTH;
  }

  const stringified = fromAnyToString(value);
  if (value !== stringified) return null;

  return RE_DIGITS.test(stringified) && stringified.length === CODE_LENGTH;
};

export default validateVerificationCode;
